<fieldset [formGroup]="group">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <div class="in-two-columns mb-4">
    <!-- year -->

    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'YEAR' | translate"
        formControlName="year"
        type="number"
        step="1"
        min="1980"
        [max]="currentYear"
      >
      </app-easy-input>
    </mat-form-field>

    <!-- wineColor -->

    <mat-form-field>
      <app-easy-select
        [label]="TITLE + 'WINE_COLOR' | translate"
        formControlName="wineColor"
        [translatePrefixForSelected]="'PRODUCTS.WINE_COLOR.'"
        [options]="wineColor | toSelectOption: 'PRODUCTS.WINE_COLOR.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- wineSweetness -->

    <mat-form-field>
      <app-easy-select
        [label]="TITLE + 'WINE_SWEETNESS' | translate"
        formControlName="wineSweetness"
        [translatePrefixForSelected]="'PRODUCTS.WINE_SWEETNESS.'"
        [options]="wineSweetness | toSelectOption: 'PRODUCTS.WINE_SWEETNESS.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- typeOfWine -->

    <mat-form-field>
      <app-easy-select
        [label]="TITLE + 'TYPE_OF_WINE' | translate"
        formControlName="typeOfWine"
        [translatePrefixForSelected]="'PRODUCTS.TYPE_OF_WINE.'"
        [options]="typeOfWine | toSelectOption: 'PRODUCTS.TYPE_OF_WINE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- characters -->

    <mat-form-field *ngIf="getCtrl('characters')">
      <app-easy-select
        [label]="TITLE + 'CHARACTERS' | translate"
        formControlName="characters"
        [translatePrefixForSelected]="'PRODUCTS.CHARACTERS.'"
        [options]="characters | toSelectOption: 'PRODUCTS.CHARACTERS.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [multiple]="true"
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <div class="w-100 in-two-columns mb-4">
    <mat-form-field>
      <app-easy-select
        [label]="TITLE + 'WINE_LANDSCAPE_UNIT_ABROAD' | translate"
        formControlName="wineLandscapeUnitAbroad"
        [translatePrefixForSelected]="'PRODUCTS.WINE_LANDSCAPE_UNIT_ABROAD.'"
        [options]="
          wineLandscapeUnitAbroad
            | toSelectOption: 'PRODUCTS.WINE_LANDSCAPE_UNIT_ABROAD.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        (ngModelChange)="onLandscapeUnitAbroadSelected($event)"
      >
      </app-easy-select>
    </mat-form-field>

    <mat-form-field>
      <app-easy-select
        [label]="TITLE + 'WINE_LANDSCAPE_UNIT_HUN' | translate"
        formControlName="wineLandscapeUnitHun"
        [translatePrefixForSelected]="'PRODUCTS.WINE_LANDSCAPE_UNIT_HUN.'"
        [options]="
          wineLandscapeUnitHun
            | toSelectOption: 'PRODUCTS.WINE_LANDSCAPE_UNIT_HUN.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        (ngModelChange)="onLandscapeUnitHunSelected($event)"
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <mat-form-field *ngIf="getCtrl('otherWineLandscapeUnitAbroad')">
    <app-easy-input
      [label]="TITLE + 'OTHER_WINE_LANDSCAPE_UNIT_ABROAD' | translate"
      formControlName="otherWineLandscapeUnitAbroad"
      type="text"
    >
    </app-easy-input>
  </mat-form-field>
</fieldset>
